export function HealthSurveyCard({
    number,
    text,
    value = null,
    onChange,
    disabled = false,
}) {
    const baseBtn =
        "h-12 min-w-[104px]  flex-1 rounded-lg font-semibold tracking-tight " +
        "transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 " +
        "disabled:opacity-60 disabled:cursor-not-allowed";

    const selectedBtn = "bg-[#DE4F4F] text-white shadow";
    const unselectedBtn = "bg-[#9F9F9F] text-white";

    const noBtn = (value === "no" ? selectedBtn : unselectedBtn) + " " + baseBtn + " focus-visible:ring-[#DE4F4F]";
    const yesBtn = (value === "yes" ? selectedBtn : unselectedBtn) + " " + baseBtn + " focus-visible:ring-[#DE4F4F]";

    return (
        <div className="w-full rounded-xl bg-white shadow-sm ring-1 ring-black/5 px-5 py-5">
            <div className="flex items-start gap-3">
                <div className="flex-1">
                    <p className="text-sm md:text-base leading-snug text-gray-800 font-semibold">{number}. {text}</p>

                    <div className="mt-4 flex text-base md:text-lg items-center gap-3 px-1" role="group" aria-label="예/아니오 선택">
                        <button
                            type="button"
                            aria-pressed={value === "no"}
                            className={noBtn}
                            onClick={() => onChange?.("no")}
                            disabled={disabled}
                        >
                            아니오
                        </button>
                        <button
                            type="button"
                            aria-pressed={value === "yes"}
                            className={yesBtn}
                            onClick={() => onChange?.("yes")}
                            disabled={disabled}
                        >
                            예
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
